// src/data/services.js  (example – update with your real images)
import service1 from '../Assets/Services/Service1-1.jpg'
// import service2 from '../Assets/Services/GC.webp'
import service3 from '../Assets/Services/Service2-1.jpg'
import service4 from '../Assets/Services/LD.webp'
import service5 from '../Assets/Services/Service4-1.jpg'
import service6 from '../Assets/Services/Dentures.webp'
import service7 from '../Assets/Services/Service6-1.jpg'
import service8 from '../Assets/Services/Orthodontics.webp'
import service9 from '../Assets/Services/Service8-1.jpg'
import service10 from '../Assets/Services/Service10-1.jpg'
import service11 from '../Assets/Services/Service11-1.jpg'




export default [
  {
    title: "Smile Designing & Cosmetic Dentistry",
    description: "Transform your smile with personalized smile makeovers, veneers, composite bonding, whitening, and aesthetic treatments for a natural, confident look in Vijayawada & Hyderabad.",
    image: service1,
    icon: "🦷",
    link: "/service/smile-Designing"
  },
  // {
  //   title: "Single Visit Dentistry with CAD CAM",
  //   description: "Get crowns, veneers, inlays, or restorations designed and placed in one appointment using advanced Dentsply Sirona CAD CAM technology for precision and convenience.",
  //   image: service2,
  //   icon: "🦷",
  //   link: "/service/singleVisit-dentistry"
  // },
  {
    title: "Dental Implants",
    description: "Advanced implant solutions including single tooth, multiple, or full mouth rehabilitation with titanium roots, CBCT planning, and natural-looking crowns for lasting function and aesthetics.",
    image: service3,
    icon: "🦷",
    link: "/service/dental-implants"
  },
  {
    title: "Periodontal Treatment",
    description: "Treat gum disease, bleeding gums, recession, and infections with advanced laser therapy using Fotona multipurpose dental laser for minimally invasive, faster healing results.",
    image: service4,
    icon: "🦷",
    link: "/service/periodontal-treatment"
  },
  {
    title: "Laser Dentistry",
    description: "Painless, precise treatments for soft and hard tissues using Fotona multipurpose laser — ideal for gum reshaping, decay removal, ulcer treatment, and more with reduced discomfort.",
    image: service5,
    icon: "🦷",
    link: "/service/laser-dentistry"
  },
  {
    title: "Root Canal (Endodontics)",
    description: "Advanced single-visit root canal therapy to save infected teeth, relieve pain quickly, and preserve natural structure using modern instruments and techniques.",
    image: service6,
    icon: "🦷",
    link: "/service/root-canal"
  },
  {
    title: "Oral & Maxillofacial Surgery",
    description: "Expert surgical care for wisdom teeth removal, impacted teeth, jaw correction (orthognathic), fractures, cysts, and pre-prosthetic procedures with advanced facilities.",
    image: service7,
    icon: "🦷",
    link: "/service/oral-surgery"
  },
  {
    title: "Pediatric Dentistry",
    description: "Gentle, child-friendly care for kids including preventive sealants, fluoride, fillings, pulp therapy, habit correction, and trauma management in a fun, stress-free environment.",
    image: service8,
    icon: "🦷",
    link: "/service/pediatric-dentistry"
  },
  {
    title: "Crowns, Bridges & Dentures",
    description: "Custom restorations with zirconia, ceramic, or implant-supported options, often in a single visit via CAD CAM, plus advanced denture solutions like BPS, flexible, and cast partial.",
    image: service9,
    icon: "🦷",
    link: "/service/crownsBridges-dentures"
  },
  // {
  //   title: "Orthodontics",
  //   description: "Correct misaligned teeth, bites, and spacing with braces or clear aligners for a balanced, beautiful smile — including early intervention for children.",
  //   image: service10,
  //   icon: "🦷",
  //   link: "/service/advanced-dentures"
  // },
  {
    title: "Advanced Denture Solutions",
    description: "Premium, natural-looking dentures including complete, BPS biofunctional, implant-supported, cast partial, flexible, and removable partial for comfort and stability.",
    image: service10,
    icon: "🦷",
    link: "/service/advanced-dentures"
  },
  {
    title: "Dental Radiology & Diagnostics",
    description: "State-of-the-art imaging with Planmeca CBCT 3D scans, Vatech OPG panoramic X-rays, and digital RVG for precise diagnosis, implant planning, and low-radiation safety.",
    image: service11,
    icon: "🦷",
    link: "/service/radiology-department"
  },
  // {
  //   title: "Radiation Safety & Patient Protection",
  //   description: "Strict safety protocols with lead aprons, thyroid collars, TLD monitoring, and AERB-certified equipment to ensure minimal radiation exposure during all imaging procedures.",
  //   image: service10,
  //   icon: "🦷",
  //   link: "/service/radiation-safety"
  // }
];
